import React, { createContext, useState, useContext, useEffect, useCallback, type ReactNode } from "react";

interface NotchContextType {
  isNotchActive: boolean;
  setIsNotchActive: (isActive: boolean) => void;
}

const NotchContext = createContext<NotchContextType | undefined>(undefined);

export const NotchProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isNotchActive, setIsNotchActive] = useState(false);

  // Memoize the setter to prevent infinite re-renders
  const setIsNotchActiveMemoized = useCallback((isActive: boolean) => {
    setIsNotchActive(isActive);
  }, []);

  useEffect(() => {
    // console.log(
    //   "[NotchProvider] isNotchActive state changed to:",
    //   isNotchActive
    // );
  }, [isNotchActive]);

  return (
    <NotchContext.Provider value={{ isNotchActive, setIsNotchActive: setIsNotchActiveMemoized }}>
      {children}
    </NotchContext.Provider>
  );
};

export const useNotch = (): NotchContextType => {
  const context = useContext(NotchContext);
  if (context === undefined) {
    throw new Error("useNotch must be used within a NotchProvider");
  }
  return context;
};
